module.exports = __webpack_public_path__ + "img/bc2105d.png";